import axios from 'axios'
import * as R from 'ramda'
import md5 from 'blueimp-md5'
import i18n from './i18n/config'
import { getGG } from './state/store'

import GatsbyConfig from './../gatsby-config'

const windowGlobal = typeof window !== 'undefined' && window


axios.defaults.timeout = 30000

const HOST = R.path(['siteMetadata', 'serviceURL'])(GatsbyConfig)
const SUCCESS = 600

const genXCheckSum  = (data) => {
  const { user } = getGG().store.getState()

  const checkSum = Object
    .keys(data)
    .sort()
    .map(key => {
      if (typeof data[key] !== 'object')
        return data[key]
      return ''
    })
    .join('') + user.key

  return md5(checkSum)
}

const getContentLanguage = () => {
  switch (i18n.language) {
    case 'en': return 'en_EN'
    case 'th':
    default: return 'th_TH'
  }
}

const generateUUID = () => { 
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
  })
}
const uuid = generateUUID()

const genConfig = (path = '', data = {}, header = {}) => ({
  url: `${HOST}${path}`,
  method: 'POST',
  headers: {
    //'X-Check-Sum_YIN': genXCheckSum(data), //the fake one to broke
    'X-Check-Sum': genXCheckSum(data), 
    'Content-Language': getContentLanguage(),
    'Content-Type': 'application/json',
    'X-Request-ID' : uuid,
    ...header,
  },
  data: JSON.stringify(data),
})

export const initSession = (lineudid, token) => axios(genConfig('/lineliff/init', {
  lineUserID: lineudid,
  token
}, {
  'X-Check-Sum': md5(`${lineudid}${token}`),
}))
.then((response) => {

    const { data } = response.data
    if(data.key ) {
      return {
        key: data.key,
        session: data.session,
        serverTime: data.serverTime,
        tokenExpire: data.tokenExpire,
        profileId: data.profileId
      }
    } else {
      //
    }
})


export const getCategoryList = () => axios(genConfig('/lineliff/privilege/category', {
  "pageNo": 1,
  "pageSize": 100
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.map(item => ({
  categoryCode: item.categoryCode,
  label: item.categoryName,
  image: item.iconImageURL,
}))(data.data.list))

export const getPrivilegeHeroBanner = (categoryCode, pageNo = 1) => axios(genConfig('/lineliff/privilege', {
  category: categoryCode,
  pageNo,
  "favourite": "none",
  "heroBanner": "yes",
  "seasonal": "none",
  "pageSize": 10,
}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => ({
    totalPage: data.data.totalPage,
    data: data.data.list
  }))

export const getBirthdayPrivilegeHeroBanner = () => axios(genConfig('/lineliff/news', {
  newsTags: "Bday-Privilege",
}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => ({
    totalPage: data.data.totalPage,
    data: data.data.list
  }))

export const getPrivilegeList = (categoryCode, pageNo = 1) => axios(genConfig('/lineliff/privilege', {
  category: categoryCode,
  pageNo,
  "favourite": "none",
  "heroBanner": "none",
  "seasonal": "none",
  "pageSize": 10,
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => ({
  totalPage: data.data.totalPage,
  data: data.data.list
}))

export const getSeasonalPrivilegeList = (categoryCode, pageNo = 1) => axios(genConfig('/lineliff/privilege', {
  category: 'all',
  pageNo,
  "favourite": "none",
  "heroBanner": "none",
  "seasonal": "yes",
  "pageSize": 10,
}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => ({
    totalPage: data.data.totalPage,
    data: data.data.list
  }))

export const getBirthdayCategoryList = () => axios(
  genConfig('/lineliff/privilege/category/birthday',
  {},
  { Authorization: `Bearer ${_genJWS()}` }
))
  .then(({ data }) => R.map(item => ({
    categoryCode: item.categoryCode,
    label: item.categoryName,
    image: item.iconImageURL,
  }))(data.data.list))
  // .catch(error => {
  //   // Handle the error here
  //   // console.error("Error in getBirthdayCategoryList:", error);
  //   // throw error; // Re-throw the error to propagate it further if necessary
  // });
  
export const getBirthdayPrivilegeList = (categoryCode, pageNo = 1) => axios(genConfig('/lineliff/privilege/birthday', {
  category: categoryCode,
  pageNo,
  pageSize: 10,
}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => ({
    totalPage: data.data.totalPage,
    data: data.data.list
  }))

export const getPrivilegeDetail = (privilegeCode) => axios(genConfig('/lineliff/privilege/detail', {
  privilegeCode
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const getUpcomingBooking = (pageNo = 1) => axios(genConfig('/lineliff/booking', {
  type: 'upcoming',
  pageNo,
  pageSize: 5
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const getBookingHistory = (pageNo = 1) => axios(genConfig('/lineliff/booking', {
  type: 'history',
  pageNo,
  pageSize: 5
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const getBookingBranch = (privilegeCode) => axios(genConfig('/lineliff/booking/branch', {
  privilegeCode
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.pathOr([], ['data', 'branchs'])(data))

export const getAvailableBookingDate = (privilegeCode, branchCode) => axios(genConfig('/lineliff/booking/date', {
  privilegeCode,
  branchCode
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => ({
  dates: R.pathOr([], ['data', 'bookingDate'])(data),
  brandName: R.pathOr([], ['data', 'brandName'])(data),
  branchName: R.pathOr([], ['data', 'branchName'])(data),
}))

export const getAvailableBookingTime = (privilegeCode, branchCode, dateCode) => axios(genConfig('/lineliff/booking/time', {
  privilegeCode,
  branchCode,
  dateCode
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => ({
  times: R.pathOr([], ['data', 'times'])(data),
  brandName: R.pathOr([], ['data', 'brandName'])(data),
  branchName: R.pathOr([], ['data', 'branchName'])(data),
}))

export const reserveBooking = (timeCode) => axios(genConfig('/lineliff/booking/reserve', {
  timeCode
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const intervalBooking = () => axios(genConfig('/lineliff/booking/interval', {

}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.path(['meta', 'responseMessage'])(data) === SUCCESS)

export const createBooking = (data) => axios(genConfig('/lineliff/booking/create', {
  bookingDetails: R.map(
    R.pick(['key', 'value'])
  )(data.bookingDetails || [])
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const editBooking = ({ bookingCode, bookingDetails }) => axios(genConfig('/lineliff/booking/detail/update', {
  bookingCode,
  type: 'edit',
  bookingDetails: R.map(
    R.pick(['key', 'value'])
  )(bookingDetails || [])
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.path(['meta', 'responseCode'])(data) === SUCCESS)

export const cancelBooking = (bookingCode) => axios(genConfig('/lineliff/booking/detail/update', {
  bookingCode,
  type: 'cancel',
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.path(['meta', 'responseCode'])(data) === SUCCESS)

export const getBookingDetails = (bookingCode) => axios(genConfig('/lineliff/booking/detail', {
  bookingCode,
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const usePrivilege = ({ useCode, refCode }) => axios(genConfig('/lineliff/privilege/use', {
  useCode,
  refCode
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.path(['meta', 'responseCode'])(data) === SUCCESS)

export const redeemPrivilege = (privilegeCode, branchCode) => axios(genConfig('/lineliff/redeem', {
  privilegeCode,
  branchCode
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const getRedeemHistory = (pageNo) => axios(genConfig('/lineliff/redeem/history', {
  pageNo,
  pageSize: 5
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const getRedeemDetail = (redeemCode) => axios(genConfig('/lineliff/redeem/detail', {
  redeemCode
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const getRedeemBranch = (privilegeCode) => axios(genConfig('/lineliff/redeem/branch', {
  privilegeCode
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.pathOr([], ['data', 'branchs'])(data))

export const getFavoriteList = (pageNo) => axios(genConfig('/lineliff/privilege', {
  "category": "all",
  "favourite": "yes",
  "heroBanner": "none",
  "seasonal": "none",
  "pageSize": 10,
  pageNo
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const addFavorite = (privilegeCode) => axios(genConfig('/lineliff/privilege/favourite', {
  privilegeCode,
  "type": "add"
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.path(['meta', 'responseCode'])(data) === SUCCESS)

export const removeFavorite = (privilegeCode) => axios(genConfig('/lineliff/privilege/favourite', {
  privilegeCode,
  "type": "remove"
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.path(['meta', 'responseCode'])(data) === SUCCESS)

export const getPrivilegeSearch = ({ keyword, pageNo = 1, pageSize = 5 }) => axios(genConfig('/lineliff/privilege/search', {
  pageNo,
  pageSize,
  keyword
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const getPrivilegeRecentSearch = () => axios(genConfig('/lineliff/privilege/search/recent',
{},
{ Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const updatePrivilegeRecentSearch = (privilegeCode) => axios(genConfig('/lineliff/privilege/search/recent/update', {
  privilegeCode
},
{ Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.path(['meta', 'responseCode'])(data) === SUCCESS)

export const getNews = ({ pageNo, pageSize } = { pageNo: 1, pageSize: 5 }) => axios(genConfig('/lineliff/news', {
  "newsTags": "news",
  pageNo,
  pageSize
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => data.data)

export const getNewsDetail = (newsCode) => axios(genConfig('/lineliff/news/detail', {
  newsCode
}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => data.data)

export const getWisdomInfo = () => axios(genConfig('/lineliff/wisdom', {}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => data.data)

export const getBirthdayHomeImage = () => axios(genConfig('/lineliff/news', {
  newsTags: "Bday-Home",
}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => R.pathOr([], ['data', 'list', '0'], data))

export const getPackageMe = () => axios(genConfig('/lineliff/package/me', {
  
}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => data.data)

export const acceptTermAndCondition = () => axios(genConfig('/lineliff/terms/accept', {}, 
  { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => R.path(['meta', 'responseCode'])(data) === SUCCESS)

export const checkTermAndCondition = () => axios(genConfig('/lineliff/terms/check', {}, 
  { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => data.data)

export const getBannerPackage = () => axios(genConfig('/lineliff/news', {
  newsTags: "Package-homebanner",
}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => R.pathOr(null, ['data', 'list', '0', 'image'], data))

export const getTermAndCondition = () => axios(genConfig('/lineliff/news', {
  newsTags: "Package-TANDC"
}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => R.pathOr(null, ['data', 'list', '0', 'newsCode'], data))

export const getPackageList = ({ pageNo, pageSize } = { pageNo: 1, pageSize: 100 }) => axios(genConfig('/lineliff/package', {
  pageNo,
  pageSize
}, { Authorization: `Bearer ${_genJWS()}` })).then(({ data }) => R.pathOr(null, ['data'], data))

export const addPackage = (packageCode) => axios(genConfig('/lineliff/package/confirm', {
  packageCode

}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => R.path(['meta', 'responseCode'])(data) === SUCCESS)

export const getPackagePrivilegeList = (pageNo = 1) => axios(genConfig('/lineliff/package/privilege', {
  pageNo,
  pageSize: 5
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => ({
  totalPage: data.data.totalPage,
  data: data.data.list
}))

export const getPackagePrivilegeGroupList = (pageNo = 1, privilegeGroupCode) => axios(genConfig('/lineliff/package/privilege/group', {
  privilegeGroupCode,
  pageNo,
  pageSize: 5
}, { Authorization: `Bearer ${_genJWS()}` }))
.then(({ data }) => ({
  totalPage: data.data.totalPage,
  data: data.data.list,
  imageHeader: data.data.imagesDetailURL
}))

export const saveStatusModalPackage = (newsCode) => axios(genConfig('/lineliff/news/accepted', {
  newsCode
}, { Authorization: `Bearer ${_genJWS()}` }))
  .then(({ data }) => R.path(['meta', 'responseCode'])(data) === SUCCESS)

export const _genJWS = () => {
  const windowGlobal = typeof window !== 'undefined' && window;
  const { user } = getGG().store.getState()

  if(windowGlobal.KJUR) {
    const requestTime = Date.now()
    const initSessionTime = user.ts
    const sHead = JSON.stringify({"alg":"HS512", "cty":"JWT"});
    const head = windowGlobal.KJUR.jws.JWS.readSafeJSONString(sHead);
    // Time tokenExpire by 1000 to convert to milliseconds
    const expTime = new Date(((new Date(user.serverTime)).getTime() + (requestTime - initSessionTime) + user.tokenExpire * 1000))
    const month = ("0" + (expTime.getMonth() + 1)).slice(-2)
    const date = ("0" + expTime.getDate()).slice(-2)
    const hours = ("0" + expTime.getHours()).slice(-2)
    const minute = ("0" + expTime.getMinutes()).slice(-2)
    const exp = `${expTime.getFullYear()}${month}${date}${hours}${minute}`
    const sPayload = {"iss":"a", "exp": exp, "idn": user.session};
    const sPemPrvKey = user.key;

    try {
      return windowGlobal.KJUR.jws.JWS.sign(head.alg, sHead, sPayload, { "b64": sPemPrvKey });
    } catch (ex) {
      console.log(ex)
    }
  }
}
